import React from "react";
import { CodedProperty, Icon, LabeledText, Stack, TooltipHost } from "sprint-common-web";

import { getLanguageDisplayName } from "../../../common/types/Language";

type LanguageDetailsInfoProps = {
    language?: CodedProperty;
    subtitleType?: string;
    inPreparation?: boolean;
    testId?: string;
};

export const LanguageDetailsInfo = (props: LanguageDetailsInfoProps): JSX.Element => {
    const { language, subtitleType, inPreparation, testId } = props;

    if (!language) {
        return <></>;
    }

    return (
        <Stack data-testId={testId}>
            <LabeledText
                direction="horizontal"
                textFontSize={12}
                labelFontSize={12}
                label="Language:"
                value={getLanguageDisplayName(language)}
                testId="language"
            />
            {!!subtitleType && (
                <Stack horizontal gap={2}>
                    <LabeledText
                        direction="horizontal"
                        textFontSize={12}
                        labelFontSize={12}
                        label="Type:"
                        value={subtitleType}
                        testId="subtitle-type"
                    />

                    {!!inPreparation && (
                        <div data-testid="dvb-generation-tooltip">
                            <TooltipHost content="Generating dvb proxy file">
                                <span style={{ cursor: "pointer" }}>
                                    <Icon iconName="Info" />
                                </span>
                            </TooltipHost>
                        </div>
                    )}
                </Stack>
            )}
        </Stack>
    );
};
